var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2500,
    height: 2500,
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M213.564 256H42.436C18.999 256 0 237.001 0 213.564V42.436C0 18.999 18.999 0 42.436 0h171.128C237.001 0 256 18.999 256 42.436v171.128C256 237.001 237.001 256 213.564 256",
    fill: "#00AEEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M131.02 107.786c-13.319 0-24.909 7.492-30.746 18.491-5.839-10.999-17.423-18.491-30.751-18.491a34.715 34.715 0 0 0-20.89 6.961V85.424a6.95 6.95 0 0 0-6.961-6.822c-3.802 0-6.862 3.033-6.949 6.822v57.742h.007c.307 18.959 15.757 34.232 34.793 34.232 13.328 0 24.912-7.499 30.751-18.487 5.837 10.988 17.427 18.487 30.746 18.487 19.216 0 34.804-15.582 34.804-34.813 0-19.221-15.588-34.799-34.804-34.799m-61.497 55.677c-11.531 0-20.89-9.341-20.89-20.873 0-11.528 9.359-20.87 20.89-20.87 11.53 0 20.869 9.342 20.869 20.865 0 11.534-9.339 20.878-20.869 20.878m61.497 0c-11.534 0-20.886-9.344-20.886-20.878 0-11.523 9.352-20.865 20.886-20.865 11.529 0 20.876 9.342 20.876 20.865 0 11.534-9.347 20.878-20.876 20.878",
    fill: "#FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M219.83 165.745l-18.918-23.205 18.941-23.25c2.395-3.067 1.708-7.35-1.598-9.625-3.31-2.295-7.954-1.707-10.515 1.269v-.004l-16.296 19.972-16.281-19.972v.004c-2.535-2.976-7.208-3.564-10.508-1.269-3.3 2.277-3.99 6.558-1.583 9.625h-.007l18.908 23.25-18.908 23.205h.007c-2.407 3.077-1.717 7.346 1.583 9.631s7.973 1.703 10.508-1.277l16.281-19.944 16.273 19.944c2.564 2.98 7.206 3.562 10.516 1.277 3.307-2.285 3.997-6.554 1.597-9.631",
    fill: "#FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.8263383fe16f5ce2b4ecb65b5a17597a.svg";
export { ForwardRef as ReactComponent };